<template>
    <img src="/static/images/image.png">
</template>

<script>
export default {
    name: 'Logo'
};
</script>

<style scoped>
    img {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue